document.querySelectorAll('[data-whatsapp-wrap]').forEach(function (wrap) {
  var btn = wrap.querySelector('[data-whatsapp-btn]');
  var closeBtn = wrap.querySelector('[data-whatsapp-close]');
  var waLink = wrap.dataset.waLink;
  var storageKey = 'pi_whatsapp_closed';

  // Daha önce kapatıldıysa bu ziyaret boyunca gösterme
  if (sessionStorage.getItem(storageKey) === '1') {
    wrap.classList.add('pi-whatsapp-wrap--hidden');
    return;
  }

  // --- Küçülme davranışı ---
  var shrinkTimer = null;

  function shrink() {
    btn.classList.add('pi-whatsapp-btn--shrunk');
  }
  function expand() {
    btn.classList.remove('pi-whatsapp-btn--shrunk');
  }
  function scheduleShrink() {
    clearTimeout(shrinkTimer);
    shrinkTimer = setTimeout(shrink, 3000);
  }

  btn.addEventListener('mouseenter', expand);
  btn.addEventListener('mouseleave', scheduleShrink);
  scheduleShrink();

  // --- Kapatma ---
  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    wrap.classList.add('pi-whatsapp-wrap--hidden');
    sessionStorage.setItem(storageKey, '1');
  });

  // --- Sürükleme ---
  var isDragging = false;
  var moved = false;
  var offsetX, offsetY;

  function startDrag(x, y) {
    isDragging = true;
    moved = false;
    var rect = wrap.getBoundingClientRect();
    offsetX = x - rect.left;
    offsetY = y - rect.top;
    clearTimeout(shrinkTimer);
    expand();
  }

  function moveDrag(x, y) {
    if (!isDragging) return;
    moved = true;
    var wrapWidth = wrap.offsetWidth;
    var wrapHeight = wrap.offsetHeight;
    var newLeft = x - offsetX;
    var newTop = y - offsetY;

    newLeft = Math.max(4, Math.min(newLeft, window.innerWidth - wrapWidth - 4));
    newTop = Math.max(4, Math.min(newTop, window.innerHeight - wrapHeight - 4));

    wrap.style.left = newLeft + 'px';
    wrap.style.top = newTop + 'px';
    wrap.style.right = 'auto';
  }

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    scheduleShrink();
  }

  btn.addEventListener('pointerdown', function (e) {
    startDrag(e.clientX, e.clientY);
  });
  window.addEventListener('pointermove', function (e) {
    moveDrag(e.clientX, e.clientY);
  });
  window.addEventListener('pointerup', endDrag);

  // --- Tıklama (sürüklenmediyse WhatsApp'ı aç) ---
  btn.addEventListener('click', function () {
    if (!moved) {
      window.open(waLink, '_blank', 'noopener');
    }
  });
});